<template>
	<section class="small-12 columns settingsTitle flex">
		<ul class="small-12 columns flex">
			<li class="small-12 flex justify-between">
				<h1 v-if="$route.name == 'SettingsCompany'">Company</h1>
				<h1 v-if="$route.name == 'SettingsResidents'">Residents Site</h1>
				<h1 v-if="$route.name == 'SettingsPayments'">Payments</h1>
			</li>
		</ul>
	</section>
</template>

<script>

	// Import firebase
	import { firebaseAuth } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'SettingsTitle',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService

		],

		/*
		**  Set the props
		*/

		props: {

			company: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			//

		}),

		/*
		**  Watch em'
		*/

		watch: {

			//

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>